import { render, staticRenderFns } from "./CMRegister.vue?vue&type=template&id=2059b89d&scoped=true&"
import script from "./CMRegister.vue?vue&type=script&lang=js&"
export * from "./CMRegister.vue?vue&type=script&lang=js&"
import style0 from "./CMRegister.vue?vue&type=style&index=0&id=2059b89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059b89d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2059b89d')) {
      api.createRecord('2059b89d', component.options)
    } else {
      api.reload('2059b89d', component.options)
    }
    module.hot.accept("./CMRegister.vue?vue&type=template&id=2059b89d&scoped=true&", function () {
      api.rerender('2059b89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/CMRegister.vue"
export default component.exports